import firebase from 'firebase';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDFjFtfh5w8T3lLUdmxL5NsoGASXSPiio4",
    authDomain: "event-awesomehub.firebaseapp.com",
    databaseURL: "https://event-awesomehub.firebaseio.com",
    projectId: "event-awesomehub",
    storageBucket: "event-awesomehub.appspot.com",
    messagingSenderId: "515451986616"
}

firebase.initializeApp(firebaseConfig);
firebase.firestore();

export default firebase;


// WEBPACK FOOTER //
// ./src/app/config/firebase.js